<template>
  <div class="search" @click="jumpSearchPage">
    <div class="tag-wrap" v-if="showTag">
      <a-typography-paragraph
        class="tag"
        :ellipsis="ellipsis"
        :content="tagText"
      ></a-typography-paragraph>
    </div>
    <p class="tag-wrap" v-else>
      {{ getText("searchTips") }}
    </p>
    <div class="ico" :style="getIcoOfBg('searchbtn')"></div>
  </div>
</template>

<script setup lang="ts">
import { useArticleStore } from "@store/article";
import { useBaseStore } from "@store/base";
import { computed } from "vue";
import { useRouter } from "vue-router";
import useLang from "@hooks/useLang";
import { Typography } from "ant-design-vue";
import { getIcoOfBg, getText } from "@config/siteConfig";
const props = defineProps({
  showTag: {
    default: 0,
  },
  source: {
    default: "",
  },
  moduleName: {
    default: "",
  },
});

const ellipsis = {
  rows: 1,
  expandable: false,
  onEllipsis: (e: boolean) => {
    console.log(e);
  },
};
const router = useRouter();
const article = useArticleStore();
const base = useBaseStore();
const { lang } = useLang();
const tagText = computed(() => {
  return article.tagList
    .map((item) => {
      return `#${
        item.CONTENT[lang.value] || item.CONTENT[base.defaultLang] || ""
      }`;
    })
    .join(" ");
});
const jumpSearchPage = () => {
  clickButtonPoint({
    btnName: "go_search",
    moduleName: props.moduleName || "",
  });
  router.push({
    path: "/search",
    query: {
      source: props.source || "",
    },
  });
};
</script>

<style scoped lang="scss">
@import "@assets/scss/dimen.scss";
@import "@assets/scss/mixin.scss";
.search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 90px;
  border-radius: 14px;
  padding: 0 20px;
  box-sizing: border-box;
  background: $layercolor;
  margin: 30px auto;
  cursor: pointer;
  &.flex-end {
    justify-content: flex-end;
  }
  .tag-wrap {
    color: $tipscolor;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-right: 30px;
    overflow-y: hidden;
    font-size: $fzNormal;
    .tag {
      font-size: $fzNormal;
      color: $tipscolor;
      margin-bottom: 0;
    }
  }
  .ico {
    flex-shrink: 0;
    display: block;
    width: 55px;
    height: 45px;
    @include addTouchEffect();
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .search {
    height: calc(90px / $pcRate);
    border-radius: calc(14px / $pcRate);
    padding: 0 calc(20px / $pcRate);
    margin: calc(30px / $pcRate) auto;

    .tag-wrap {
      margin-right: calc(30px / $pcRate);
      font-size: calc($fzNormal / $pcRate);
      .tag {
        font-size: $fzNormalPc;
      }
    }
    .ico {
      width: calc(55px / $pcRate);
      height: calc(45px / $pcRate);
    }
  }
}
</style>
